export default __webpack_public_path__ + "static/media/14554.dutch-banking-tour-committee.photo.2ac680b7.jpg";